export default {
  app: {
    featured: 'Destacadas',
    random: 'Aleatorio',
    explore: 'Explora',
    keywords: 'Palabras Craves',
    search: 'Procura',
  },
  explore: {
    filters: 'Filtros',
    resetFilters: 'Reiniciar filtros',
    addKeyword: 'Agregar palabra chave',
  },
  recipe: {
    contributedBy: 'Achegado por',
    ingredients: 'Ingredientes',
    directions: 'Instrucións',
    fullRecipe: 'Mira a receita completa en',
    similarDrinks: 'Bebidas similares',
  },
  featuredRecipes: {
    loadMore: 'Cargar máis',
  },
  recipeFind: {
    filterBy: 'Filtrar por',
    name: 'Nomee',
    ingredients: 'Ingredientes',
    keywords: 'Palabras chave',
    searchForIngredients: 'Podes buscar múltiples ingredientes separándoos con espazos',
    searchForKeywords: 'Podes buscar múltiples palabras craves separándoas con espazos',
  },
  recipeList: {
    viewRecipe: 'Ver receita',
  },
  recipeToolbar: {
    print: 'Imprimir',
    share: 'Compartir',
    shareOnFacebook: 'Compartir en Facebook',
    shareOnTwitter: 'Compartir en Twitter',
    copyURL: 'Copiar URL',
    hideImage: 'Ocultar imaxe',
  },
  favorites: {
    removeAllFavorites: 'Eliminar todos os favoritos',
    noFavoriteDrinks: 'Non tes bebidas favoritas',
    removeFavoritesPrompt: 'Estás seguro que queres eliminar todos os favoritos？',
    delete: 'Eliminar',
    cancel: 'Cancelar',
  },
  search: {
    findYourDrink: 'Atopa a túa bebida',
  },
  pageNotFound: {
    pageNotFound: 'Non se atopou a páxina que estás a buscar',
    backToHome: 'Volver ao comezo',
  },
};
